import { getDownloadURL, ref } from 'firebase/storage'
import { storage } from '../firebase-init'

export async function getAssetLinkFromStorage(path?: string) {
  return getDownloadURL(ref(storage, path))
}
